import React,{useState,useEffect} from 'react'
import MaterialTable from 'material-table';
import Axios from 'axios';


import {MDBRow, MDBCol, MDBContainer,MDBIcon,MDBModal,MDBCard,MDBCardBody,
    MDBCardHeader,MDBCardFooter,MDBBtn,MDBBtnGroup  } from 'mdbreact';
    import { toast,ToastContainer } from 'react-toastify';



import "../css/scrollbar.css";

import AccessDenied from '../components/AccessDenied';


import AddEditDealerPrices from './AddEditDealerPrices';



const DealerPrices=(props)=>{

  const bearer={
    headers: {
       Authorization: "Bearer " + sessionStorage.getItem("hash")
    }
  }
  const [rows, setRows] = useState([]);
  const [showPreloader,setPreloader]=useState("normal");
  const [strTransactions,setTransactions]=useState("");
  const [selRow,setSelectedRow]=useState("");
   
  const [modalAddEdit,showAddEdit]=useState(false);


  const toggleAddEdit = (transtype) => {

   
    setRows([]);
   
   
        showAddEdit(!modalAddEdit);
   
    loadData();
  
  }
  
 

  const toastId = React.useRef(null);

  const notify = (message) => {
      toastId.current = toast.info(message);
    
    }


  const [bRefresh,setRefresh]=useState(false);

 const refreshGrid =(message)=>{
   
     setRows([]);
      setRefresh(!bRefresh);
   
      loadData();
      notify(message);
      
    
    
  }


  const showResult =(message)=>{
    setRefresh(!bRefresh);
  
    setRows([]);
  
   
    // loadData(); 
  
    loadData();
   
  
    toast.info(message, {
        closeButton: false
        
      });
    
    
  }

  const [isAdmin,checkAdmin]=useState(0);


         
  function checkAdminAccess() {
      
  
    Axios.get(props.apiServer + "/getadminaccess?username=" + sessionStorage.getItem("msal.uc"),bearer)
     .then(res => {
     
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
     })
   
     .catch(error => {
      
      console.log(error);
     });  
    
   
   
   
   }
   
  function loadData() {
    
    Axios.get(props.apiServer + "/dealerpricelist?dealer=" + props.dealercode ,bearer)
     .then(res => {
       
       setRows(res.data);
        setPreloader("none");
    
     })
   
     .catch(error => {
      
      console.log(error);
     });  
    
   
   
   
   }


  const useMountEffect = (functionName) => useEffect(functionName, [])


  useMountEffect(checkAdminAccess);
    useMountEffect(loadData);

  


if( isAdmin==0 ) 
{

  return (
    <React.Fragment>

    <AccessDenied />
    </React.Fragment>
   
    
    );
}
  
 

  return (
    <React.Fragment > 
<MDBRow className="pt-3"> 
<MDBCol md='12' className="mb-4">
      <MDBBtnGroup size="sm">
      <MDBBtn className="green" title="Add New Transaction" onClick={toggleAddEdit}>
                  <MDBIcon icon="plus" className="pr-2" />
                 Add New 
                </MDBBtn>
    
      
      </MDBBtnGroup>
    </MDBCol>
  <MDBCol md="12">

               
  </MDBCol>

</MDBRow>


       <MDBRow > 
      
            <MDBCol  md="12">
            { showPreloader==="normal" ? 
              ( 

                <MDBRow>
                <MDBCol md="4">

                </MDBCol>
                <MDBCol  md="4" className="text-center">
                <br/>  
                <img src={props.deployURL + "/loading.gif" } style={{width:"300px",textAlign:"center"}} alt="loading" />
                <br/>
                
                </MDBCol>
                <MDBCol  md="4">
                  
                </MDBCol>


              </MDBRow>
            
              )
              :
              (
                <React.Fragment>
{/*                 
                <MDBRow>
                <MDBCol md="8">
                
                <h6  style={{fontFamily:"Montserrat",fontWeight:"400"}} className="display-5 blue-grey-text ml-1"> TRANSACTIONS</h6>
                   
                 </MDBCol>
                <MDBCol md="4">
                 <a href="#" className="float-right" onClick={toggleAddEdit}> <MDBIcon icon="plus" size="2x" className="blue-text" title="Add New Transaction" /> &nbsp;Add New Transaction</a>
                 </MDBCol>
                  
                </MDBRow> */}
               
                <MaterialTable

                  title=""

                

                  columns={[
                    
                    { title: "Bundle", field: 'bundle'
                      
                    },

                    { title: "code", field: 'code',hidden:true
                      
                    },
                    { title: 'Price', field: 'price'

                    },
                    { title: "Bundle", field: 'bundle',
                      
                    }
                   
                  ]}




                  data={rows
                  }



                  options={{
                    search: true,
                    actionsColumnIndex: -1,
                  
                  }}





                  detailPanel={[
                  {
                  icon: ()=> <MDBIcon icon="list" className="blue-text" />,
                  openIcon: ()=><MDBIcon icon="chevron-circle-down"  className="red-text" />,
                  tooltip:"Dealer Price Details",
                  render: rowData => {
                  return (



                 
               
                    <MDBContainer className="ml-0" >
                       <MDBCardHeader className="cloudy-knoxville-gradient">
                            <span className="font-weight-bold"> Charge Details
                              </span>
                          </MDBCardHeader>  
                        <MDBCardBody>
                        <AddEditDealerPrices
                         deployURL={props.deployURL}
                         apiServer={props.apiServer}
                         code={rowData.code }
               
                         dealercode={props.dealercode}
                         apiServerHybrid={props.apiServerHybrid}
                          toggleModal={toggleAddEdit}
                         refreshGrid={refreshGrid}
                        showResult={showResult}
                        >

                        </AddEditDealerPrices>
                        </MDBCardBody>
                       <MDBCardFooter >
                                
                       </MDBCardFooter>
                
                     </MDBContainer>


                  )
                  }

                  }
                    
                
                      
                    ]}

                    />  


               
                </React.Fragment>
              )
              
              
            
            }

            </MDBCol>
        </MDBRow>
       

        <MDBModal
              
              backdrop={false}
              isOpen={modalAddEdit}
              toggleModal={toggleAddEdit}
              fullHeight
              position="right"
              size="lg"
          >
             
          <MDBCard>
            <MDBCardHeader className="blue-gradient">
              <h5 className="h5-responsive white-text"><b>ADD DealerPrices</b></h5>
            </MDBCardHeader>
            <MDBCardBody>
       
                   <AddEditDealerPrices
                         deployURL={props.deployURL}
                         apiServer={props.apiServer}
                         code="new"
                       
                         dealercode={props.dealercode}
                         apiServerHybrid={props.apiServerHybrid}
                         toggleModal={toggleAddEdit} 
                         refreshGrid={refreshGrid}
                     
                        >

                        </AddEditDealerPrices> 
               
       
            </MDBCardBody>
          </MDBCard>
             

               
              {/* <AddEditDirectiveDetails toggleModal={toggleAddEdit} code={"newrecord"} directivecode={props.code}  apiServer={props.apiServer} loadDirectivesMain={props.loadDirectivesMain}/> */}
                               
              

          
             
          </MDBModal>


          
            

          <ToastContainer
                hideProgressBar={true}
                newestOnTop={true}
                autoClose={2000}
               
                />
     {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
                  
    </React.Fragment>
   
  )
}



export default DealerPrices
